/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-15 17:38:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-09-27 21:36:46
 * @FilePath: \baishu_react_ui\src\Login\BsyRadioGroup\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import { BsyUtils } from "../../utils/Utils";
import BsyAddress from "../BsyAddress";
import BsyMsgBubble from "../BsyMsgBubble";
import { BsyWidget } from "../BsyWidget";
import "./index.css";
import BsySubformBase from "../BsySubformBase";
import _ from "lodash";
class BsySubformAddress extends BsySubformBase {
  static defaultProps = {
    baseCls: "bsy-subform-address",
    onAfterItemSelect: null,
    onItemCreate: null,
    onStopEdit: null,
    repeatBtn: !1,
    allowBlank: !0,
    layout: "",
    items: [],
    colorEnable: !1,
    otherInputWidth: 180,
    onStateChange: null,
    stopCancel: !1, //禁止取消选中状态
  };

  constructor(props) {
    super({
      baseCls: "bsy-address",
      needDetail: !0,
      format: "pcda",
      allowBlank: !0,
      width: "100%",
      openMapAddress: true,
      seleceMapAddress: true,
      ...props,
    });

    this.element = React.createRef();
    this.value = null;
  }

  getValue = () => {
    const { value } = this.state;
    return value;
  };

  getAddressContext = (context) => {
    this.addressContext = context;
  };

  componentWillUnmount() {
    const { subform } = this.options;
    if (subform && this.hasFocus) {
      this.hasFocus = false;
      BsyUtils.applyFunc(
        this,
        this.options.onStopEdit,
        [this.value, null, this],
        !1
      );
    }
  }
  popUpPane = () => {
    const { items, value } = this.state;
    let that = this;
    that.value = value;
    return (
      <BsyAddress
        getContext={that.getAddressContext}
        format={this.props.format}
        seleceMapAddress={this.props.seleceMapAddress}
        value={value}
        width={"auto"}
        onStopEdit={(e) => {
          that.setState(
            {
              value: { ...e },
            },
            () => {
              // BsyUtils.applyFunc(that, that.props.onStopEdit, [e, null, that], !1)
              // ref.closeAlter();
            }
          );
        }}
      ></BsyAddress>
    );
  };

  popUpPaneClose = (e) => {
    let that = this;
    const { eventMode } = this.options;
    let value = that.addressContext.getValue();

    if (BsyUtils.closestClass(e.target, "x-dialog")) {
      return !0;
    }

    //由于弹出层关闭的时间比 控制触发焦点的时间要快，所以只能在关闭的时候取地址的值
    if (!this.value && !value) {
      this.addressContext = null;
      return !1;
    }

    value = value || {};
    that.value = that.value || {};

    if (!_.isEqual(that.value, value)) {
      let trgrevent = false;

      if (BsyUtils.isObjectEmpty(eventMode)) {
        trgrevent = true;
      }

      if (eventMode == 1) {
        trgrevent = true;
      }
      if (eventMode == 2) {
        if (
          that.value.province == value.province &&
          that.value.city == value.city &&
          that.value.district == value.district
        ) {
        } else {
          trgrevent = true;
        }
      }
      if (eventMode == 3) {
        if (that.value && value) {
          if (that.value.detail != value.detail) {
            trgrevent = true;
          }
        } else {
          if (this.value && this.value.detail && !value) {
            trgrevent = true;
          }
        }
      }
      that.value = { ...value };
      that.setState(
        {
          value: value,
        },
        () => {
          BsyUtils.applyFunc(
            that,
            that.props.onAfterEdit,
            [value, null, that],
            !1
          );
          if (trgrevent) {
            BsyUtils.applyFunc(
              that,
              that.props.onStopEdit,
              [value, null, that],
              !1
            );
          }
        }
      );
    }

    if (BsyUtils.closestClass(e.target, "fx_address_select_map")) {
      return;
    }
    this.addressContext = null;
    return !1;
  };

  renderDisablePane = () => {
    const { value } = this.state;
    const { format } = this.options;
    let valstr = BsyUtils.address2Str(value, format || "pcda");
    return (
      <div
        ref={this.element}
        className={"bsy_form_item_disable "}
        data-watermark={React.language("content.empty")}
        title={valstr}
      >
        {valstr}
      </div>
    );
  };

  render() {
    const { value } = this.state;
    const { cssName, format, css } = this.options;

    if (!this.isEnabled()) {
      return this.renderDisablePane();
    }

    let valstr = BsyUtils.address2Str(value, format || "pcda", "-");
    return (
      <div
        className={cssName}
        style={css}
        ref={this.element}
        onClick={(e) => {
          this._onTriggerClick(e, 340);
        }}
      >
        <div className="select-trigger">
          <span className="select-val">{valstr}</span>
          {this.renderBtn("icon-bsy-xia", valstr)}
        </div>
      </div>
    );
  }
}

export default BsySubformAddress;
